.slider-item {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* ليتناسب مع ارتفاع السلايدر */
}
.swiper-slide img {
  object-fit: cover;
}

.swiper-slide{
  background-color: transparent !important;

}